/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required, @atlaskit/volt-strict-mode/no-re-exports, @atlaskit/editor/no-re-export -- VOLTC-139 tracks removal of these deprecated re-export shims. */
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */
// These types have been converted from frozen objects to enums.
// We cannot change their name, or even capitalise them without breaking API.
export enum envType {
	LOCAL = 'local',
	DEV = 'dev',
	STAGING = 'staging',
	PROD = 'prod',
}

export enum eventType {
	TRACK = 'track',
	UI = 'ui',
	OPERATIONAL = 'operational',
	SCREEN = 'screen',
	IDENTIFY = 'identify',
}

export enum platformType {
	MAC = 'mac',
	LINUX = 'linux',
	WINDOWS = 'windows',
	/**
	 *  @deprecated desktop is here for retrocompatibility, please select one of the above OS instead.
	 */
	DESKTOP = 'desktop',
	WEB = 'web',
	MOBILE_WEB = 'mobileWeb',
}

export enum originType {
	DESKTOP = 'desktop',
	WEB = 'web',
}

export enum tenantType {
	CLOUD_ID = 'cloudId',
	ORG_ID = 'orgId',
	OPSGENIE_CUSTOMER_ID = 'opsgenieCustomerId',
	HALP_TEAM_ID = 'halpTeamId',
	LOOM_ORG_ID = 'loomOrgId',
	TRANSACTION_ACCOUNT_ID = 'transactionAccountId',
	TRELLO_WORKSPACE_ID = 'trelloWorkspaceId',
	JA_WORKSPACE_ID = 'jiraAlignWorkspaceId',
	STUDIO_WORKSPACE_ID = 'studioWorkspaceId',
	NONE = 'none',
}

export enum productEmbedType {
	FIRST_PARTY = 'FIRST_PARTY',
	THIRD_PARTY = 'THIRD_PARTY',
}

export enum userType {
	ATLASSIAN_ACCOUNT = 'atlassianAccount',
	HASHED_EMAIL = 'hashedEmail',
	LOOM = 'loom',
	TRELLO = 'trello',
	OPSGENIE = 'opsgenie',
	JA_USER_ID = 'jiraAlign',
	HALP = 'halp',
}

export enum apdexType {
	TRANSITION = 'transition',
	INITIAL_LOAD = 'initialLoad',
}

export const desktopPlatforms: readonly platformType[] = Object.freeze([
	platformType.DESKTOP,
	platformType.MAC,
	platformType.LINUX,
	platformType.WINDOWS,
]);

export const webPlatforms: readonly platformType[] = Object.freeze([
	platformType.WEB,
	platformType.MOBILE_WEB,
]);

export enum originTracingType {
	ATL_ORIGIN = 'atlOrigin',
}

export enum perimeterType {
	C5 = 'c5',
	COMMERCIAL = 'commercial',
	FEDRAMP_MODERATE = 'fedramp-moderate',
	FEDRAMP_HIGH = 'fedramp-high',
}

export enum aliasType {}

export enum groupType {
	TRANSACTION_ACCOUNT_ID = 'transactionAccountId',
}

export enum envOverrides {}

/**
 * @deprecated Import directly from `./object-values` instead of this re-export.
 */
/**
 * @deprecated Use `import { objectValues } from '@atlassiansox/analytics-web-client'` instead.
 */

export { objectValues } from './objectValues';
/**
 * @deprecated Import directly from `./is-type` instead of this re-export.
 */
/**
 * @deprecated Use `import { isType } from '@atlassiansox/analytics-web-client'` instead.
 */
export { isType } from './isType';
